import Link from "next/link";
import getConfig from "next/config";

import { resizeImage } from "@lib/helpers";
import Price from "@components/Price";
import AddToCart from "@containers/Catalog/Actions/AddToCart";
import CartIcon from "@components/Icons/Cart";

const {
  publicRuntimeConfig: { settings, content },
} = getConfig();

const BundleItem = ({
  bundleProductsCount,
  bundleProductIndex,
  bundleProduct,
}) => (
  <>
    <div className="relative flex justify-between h-full">
      <div className="mr-[16px]">
        <Link href={`/${bundleProduct.url_key}/cpd/${bundleProduct.sku}/`}>
          <a className="flex justify-center relative">
            <div className="w-[120px]">
              <img
                src={resizeImage(
                  bundleProduct.thumbnail ||
                    bundleProduct.small_image ||
                    bundleProduct.image,
                  "300x300"
                )}
                alt={bundleProduct.name}
              />
            </div>

            {bundleProduct.quantity > 1 && (
              <div className="bg-red-brand absolute font-bold text-sm rounded-[30] text-center text-white min-w-[30] px-3 h-[30] left-0 top-0 leading-[30px]">
                {bundleProduct.quantity}x
              </div>
            )}
          </a>
        </Link>
      </div>

      {/* desktop view separator */}
      <div
        aria-hidden="true"
        className="hidden md:block absolute text-[44px] -right-[22px] z-[1] top-1/2 -translate-y-1/2 select-none text-yellow"
      >
        {bundleProductIndex < bundleProductsCount - 1 && "+"}
      </div>

      <div className="flex flex-col justify-between flex-1">
        <Link href={`/${bundleProduct.url_key}/cpd/${bundleProduct.sku}/`}>
          <a className="block line-clamp-3 mb-2 text-[14px]">
            {bundleProduct.name || ""}
          </a>
        </Link>

        {/* desktop view price and add to cart */}
        <div className="hidden md:flex flex-col w-full space-y-2 mt-1">
          <Price
            price={bundleProduct.price}
            regularPrice={bundleProduct.regularPrice}
            formatted={true}
            displayDiscount={true}
            discountType={bundleProduct.discount_type}
            msrp={bundleProduct.msrp_price}
            isBundle
            size="smaller"
          />

          <AddToCart
            iconOnly
            noMargin={false}
            product={{
              stock_status: 1,
              sku: bundleProduct.sku,
              mainOffer: 0,
              offers: [
                {
                  stock: { status: 1 },
                  seller: {
                    id: settings.websiteId,
                    identifier: settings.websiteName,
                    url_key: bundleProduct.websiteName,
                    name: content.websiteTitle,
                    order: 1,
                  },
                },
              ],
            }}
          />
        </div>
      </div>
    </div>

    {/* mobile view price and add to cart */}
    <div className="flex gap-[16px] items-center justify-end w-full md:hidden">
      <Price
        price={bundleProduct.price}
        regularPrice={bundleProduct.regularPrice}
        formatted={true}
        displayDiscount={true}
        discountType={bundleProduct.discount_type}
        msrp={bundleProduct.msrp_price}
        isBundle
        size="smaller"
      />

      <AddToCart
        iconOnly
        noMargin
        product={{
          stock_status: 1,
          sku: bundleProduct.sku,
          mainOffer: 0,
          offers: [
            {
              stock: { status: 1 },
              seller: {
                id: settings.websiteId,
                identifier: settings.websiteName,
                url_key: bundleProduct.websiteName,
                name: content.websiteTitle,
                order: 1,
              },
            },
          ],
        }}
      />
    </div>

    {/* mobile view separator */}
    <div className="text-yellow md:hidden h-[30px] text-5xl leading-[30px] left-0 right-0 text-center bottom-[-30px] select-none">
      {" "}
      {bundleProductsCount - 1 === bundleProductIndex ? "=" : "+"}{" "}
    </div>
  </>
);

export default BundleItem;
